export default __webpack_public_path__ + "static/01_healthy-platform-382c2d841adf273c169fb42e4365d234.png";